import "./ProductsPageSkeleton.css";

function Skeleton({ className = "" }) {
  return <div className={`skeleton ${className}`} />;
}

export default function ProductsPageSkeleton({
  productCount = 12,
}) {
  return (
    <div className="products-page-skeleton" dir="rtl">

      {/* Breadcrumb */}
      <div className="skeleton-breadcrumb">
        <Skeleton className="skeleton-breadcrumb-item" />
        <span>/</span>
        <Skeleton className="skeleton-breadcrumb-item short" />
        <span>/</span>
        <Skeleton className="skeleton-breadcrumb-item medium" />
      </div>

      <div className="skeleton-home-layout">

        {/* ================= SIDEBAR ================= */}
        <aside className="skeleton-sidebar">

          {/* Filter header */}
          <div className="skeleton-filter-header">
            <Skeleton className="skeleton-icon" />
            <Skeleton className="skeleton-title" />
          </div>

          {/* Search */}
          <Skeleton className="skeleton-input" />

          {/* Filter sections */}
          <div className="skeleton-filter-section">
            <Skeleton className="skeleton-section-title" />

            {[1, 2, 3, 4, 5].map((item) => (
              <div className="skeleton-checkbox" key={item}>
                <Skeleton className="skeleton-checkbox-box" />
                <Skeleton className="skeleton-checkbox-text" />
              </div>
            ))}

            <Skeleton className="skeleton-more-button" />
          </div>

          {/* Price */}
          <div className="skeleton-filter-section">
            <Skeleton className="skeleton-section-title" />

            <Skeleton className="skeleton-price-text" />
            <Skeleton className="skeleton-price-slider" />

            <div className="skeleton-price-values">
              <Skeleton />
              <Skeleton />
            </div>

            <Skeleton className="skeleton-apply-button" />
          </div>

          {/* Other filters */}
          <div className="skeleton-filter-section">

            {[1, 2, 3].map((item) => (
              <div className="skeleton-checkbox" key={item}>
                <Skeleton className="skeleton-checkbox-box" />
                <Skeleton className="skeleton-checkbox-text" />
              </div>
            ))}

          </div>

        </aside>

        {/* ================= CONTENT ================= */}
        <main className="skeleton-products-content">

          {/* Header */}
          <div className="skeleton-products-header">

            <div>
              <Skeleton className="skeleton-main-title" />
              <Skeleton className="skeleton-sub-title" />
            </div>

            <div className="skeleton-total">
              <Skeleton className="skeleton-total-title" />
              <Skeleton className="skeleton-total-number" />
            </div>

          </div>

          {/* Category image */}
          <Skeleton className="skeleton-category-image" />

          {/* Desktop sort */}
          <div className="skeleton-sort-bar">

            <Skeleton className="skeleton-sort-label" />

            {[1, 2, 3, 4, 5, 6].map((item) => (
              <Skeleton
                key={item}
                className="skeleton-sort-button"
              />
            ))}

          </div>

          {/* Product grid */}
          <div className="skeleton-products-grid">

            {Array.from({ length: productCount }).map((_, index) => (
              <ProductCardSkeleton key={index} />
            ))}

          </div>

          {/* Pagination */}
          <div className="skeleton-pagination">

            <Skeleton className="skeleton-page-button" />

            {[1, 2, 3, 4, 5].map((item) => (
              <Skeleton
                key={item}
                className="skeleton-page-number"
              />
            ))}

            <Skeleton className="skeleton-page-button" />

          </div>

          {/* Description */}
          <div className="skeleton-description">

            <Skeleton className="skeleton-description-title" />

            <Skeleton className="skeleton-description-line" />
            <Skeleton className="skeleton-description-line" />
            <Skeleton className="skeleton-description-line short" />

          </div>

        </main>
      </div>
    </div>
  );
}


/* =====================================================
   PRODUCT CARD
===================================================== */

function ProductCardSkeleton() {
  return (
    <div className="skeleton-product-card">

      {/* Image */}
      <Skeleton className="skeleton-product-image" />

      {/* Badge */}
      <Skeleton className="skeleton-product-badge" />

      {/* Brand */}
      <Skeleton className="skeleton-product-brand" />

      {/* Title */}
      <div className="skeleton-product-title">
        <Skeleton />
        <Skeleton />
      </div>

      {/* Rating */}
      <div className="skeleton-product-rating">
        <Skeleton />
        <Skeleton />
      </div>

      {/* Price */}
      <div className="skeleton-product-price">
        <Skeleton className="skeleton-old-price" />
        <Skeleton className="skeleton-current-price" />
      </div>

      {/* Cart */}
      <Skeleton className="skeleton-cart-button" />

    </div>
  );
}